import sunburst from "./components/sunburst";

//slots info
import nodeInfoDisplayer from "./components/nodeInfoDisplayer";
import breadcrumbTrail from "./components/breadcrumbTrail";
//slots behaviors
import highlightOnHover from "./components/behavior/highlightOnHover";
import zoomOnClick from "./components/behavior/zoomOnClick";

import { colorSchemes } from "./infra/colorSchemes";

export {
  breadcrumbTrail,
  colorSchemes,
  highlightOnHover,
  nodeInfoDisplayer,
  sunburst,
  zoomOnClick
};
